(function(){
  var ua = navigator.userAgent || '';
  if (!/Android/i.test(ua)) return;
  if (/wv\)|FBAN|FBAV|Instagram/i.test(ua)) return;
  if (/^\/(pages\/app|checkouts|cart)/.test(location.pathname)) return;
  var KEY = 'of_app_banner_closed';
  try { var t = +localStorage.getItem(KEY) || 0; if (Date.now() - t < 7*864e5) return; } catch (e) {}
  var ar = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var URL = 'https://play.google.com/store/apps/details?id=com.optimumfusion';
  function build() {
    if (document.getElementById('ofAppBar')) return;
    var b = document.createElement('div');
    b.id = 'ofAppBar';
    b.setAttribute('dir', ar ? 'rtl' : 'ltr');
    b.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:9998;background:#083545;color:#fff;display:flex;align-items:center;gap:10px;padding:10px 12px;font:600 14px/1.3 system-ui,Arial,sans-serif;box-shadow:0 -2px 10px rgba(0,0,0,.25)';
    var x = document.createElement('button');
    x.type = 'button'; x.setAttribute('aria-label', ar ? 'إغلاق' : 'Close'); x.textContent = '×';
    x.style.cssText = 'background:none;border:0;color:#fff;font-size:24px;line-height:1;padding:0 6px;cursor:pointer';
    x.onclick = function () { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} b.remove(); };
    var s = document.createElement('span');
    s.style.cssText = 'flex:1';
    s.textContent = ar ? 'تسوّق أسرع من تطبيق Optimum Fusion' : 'Shop faster in the Optimum Fusion app';
    var a = document.createElement('a');
    a.href = URL; a.textContent = ar ? 'افتح / حمّل' : 'Open / Get';
    a.style.cssText = 'background:#fff;color:#083545;text-decoration:none;padding:8px 14px;border-radius:8px;font-weight:700;white-space:nowrap';
    b.appendChild(x); b.appendChild(s); b.appendChild(a);
    document.body.appendChild(b);
  }
  if (document.body) build(); else document.addEventListener('DOMContentLoaded', build);
})();
